import React, {useEffect, useMemo, useState} from 'react';
import {PageHeader} from "../../../components/PageHeader";
import {extractObject, initHeaderOrders, simmsColumnsToJsGridHeaders, toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import {addMonths, addYears} from "date-fns";
import {getAccessLogBarChart, getAccessLogList} from "../../../api/accessLog/AccessLogService";
import {useDispatch} from "react-redux";
import {setKeys} from "../../../redux/slice/searchSlice";
import useRequestData from "../../../hooks/useRequestData";
import {AccessLogCompanyBarChart, AccessLogTrendChart} from "./AccessLogCharts";
import {ACCESS_LOG_HEADER} from "../../../components/table/header/Headers";
import Search from "../../../components/search/Search";
import SimmsJsGrid from "../../../components/js-grid/SimmsJsGrid";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../api/user/UserAccountService";
import {useExcelDownloadClick} from "../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../components/js-grid/JsGridExcelGridOpenButton";
import "../fieldMng/shared/codeManageSettings.css";
import "./accessLog.css";

function AccessLog() {
    const [barChart, setBarChart] = useState();
    const [lineChart, setLineChart] = useState();
    const [header, setHeader] = useState({order: ACCESS_LOG_HEADER, exclude: []});

    const dp = useDispatch();
    dp(setKeys({keys: "AccessLog"}));

    const initDate = {
        startDate: toKSTISOString(addMonths(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    };

    const {newData, pageInfo, dataHook} = useRequestData(getAccessLogList, initDate, "access_log");
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;

    const searchDate = {
        startDate: saveConditions.startDate ?? initDate.startDate,
        endDate: saveConditions.endDate ?? initDate.endDate,
    };

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, ACCESS_LOG_HEADER, setHeader, [], () => {}, () => {}, 'access_log');
        });
    }, []);

    useEffect(() => {
        getAccessLogBarChart(saveConditions).then((res) => {
            if (res?.status === 200) {
                setBarChart(res.data.barChart);
                setLineChart(res.data.lineChart);
            }
        });
    }, [saveConditions]);

    const accessLogJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    return (
        <div className="common-container container-height-full code-manage-scope">
            <PageHeader header="접속통계" indicator="환경설정 > 접속통계" />

            <div className="access-log-page container-height">
                <Search
                    refresh={refresh}
                    entity="access_log"
                    searchConditions={saveConditions}
                    handleSearch={handleSearch}
                    handlePageSizeChange={handlePageSizeChange}
                    pageInfo={pageInfo}
                    date={searchDate}
                    size
                />

                <div className="access-log-charts">
                    <div className="access-log-chart-card">
                        <h3 className="access-log-chart-card__title">일자별 통계</h3>
                        <div className="access-log-chart-card__body">
                            {lineChart && <AccessLogTrendChart lineChart={lineChart} />}
                        </div>
                    </div>
                    <div className="access-log-chart-card">
                        <h3 className="access-log-chart-card__title">업체별 통계</h3>
                        <div className="access-log-chart-card__body">
                            {barChart && <AccessLogCompanyBarChart items={barChart.data} />}
                        </div>
                    </div>
                </div>

                <div className="container-height-body">
                    <SimmsJsGrid
                        loading={dataHook.loading}
                        resizable={true}
                        data={newData}
                        theme="linear"
                        style={{minHeight: 0, height: '100%'}}
                        header={accessLogJsGridHeader}
                        onHeaderSave={(v) => setIndividualSetting({headers: {access_log: v}})}
                        onHeaderReset={() => resetIndividualSetting('headers', 'access_log')}
                        onPageChange={handleGridPageChange}
                        toolbarEnd={() => (
                            <div className="flex items-center gap-4">
                                <JsGridExcelGridOpenButton entityName="AccessLog" search={excelGridSearch} />
                            </div>
                        )}
                    />
                </div>
            </div>
        </div>
    );
}

export default AccessLog;
